(function (ws) {
    'use strict';
    ws.views.quotePageForms = ws.views.googleAnalytics.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'quote_request',
        GTM_EVENT_UPLOAD_FILE_ACTION: 'add_product_quote_file',
        GTM_EVENT_PART_NUMBER_ACTION: 'add_product_part_numbers',
        GTM_EVENT_VENDOR_ACTION: 'add_product_vendor_reference',

        events: {
            'click  .quf-id-form-submit': 'checkIdForm',
            'click .quf-upload-submit': 'checkUploadFileForm',
            'change .required': 'resetForm',
            'change .unique': 'resetForm',
            'click .quf-bom-submit': 'checkBOMForm',
            'click .quf-upload-button': 'confirmUpload',
            'change .upload': 'processFile',
            'click .quf-file-type-row a': 'showTooltip',
            'click .quf-nav': 'showModal',
            'click .icon-trash': 'deleteFile',
            'change .quf-vendor-select': 'updateVendorSelect',
            'change .select-vendor-ref': 'updateVendorSelectRef',
            'change .checkedInp': 'toggleOptionInputBox'
        },

        /**
         * Initialize
         */
        initialize: function () {
            //globals
            this.$copyBom = this.$('.quf-copy-paste');
            this.$dealId = this.$('.quf-enter-id');
            this.$copyBomGlobalMsgs = this.$('.quf-bom-global-messages');
            this.$errors = this.$('.quf-error');
            this.$globalErrors = this.$('.global.error-message');
            this.$vendorErrorMessage = this.$('.quf-vendor-select-error');
            this.$fileUploadError = this.$('.quf-file-upload-error');
            this.$fileUploadFormatError = this.$('.quf-file-upload-format-error');
            this.$vendorRefNumb = this.$('.vendor-ref');
            this.$optionalQuoteNo = this.$('.optQuoteNo');

            //file upload form
            this.$uploadFileTpl = this.$('#uploadFileNameTpl');
            this.$uploadFile = this.$('.quf-upload');
            this.$uploadInput = this.$('.upload')[0];
            this.$fileName = this.$('.quf-file-name');
            this.$uploadForm = this.$('.quf-upload-form');
            this.$bomCheckbox = this.$('#quf-upload-bom');
            this.bomFileTypes = 'application/vnd.ms-excel';
            this.bomExtensions = 'xls';
            this.$multiUpload = this.$('#multi-upload');

            //modals
            this.successModalId = this.$uploadFile.find('form').data('modalonsuccess');
            this.confirmModalId = this.$uploadFile.find('form').data('modalonconfirmation');
            this.uploadSuccessModalId = this.$uploadFile.find('form').data('modalonsuccessupload');
            _.bindAll(this, 'continueUpload');
            this.eventAgg.on(this.confirmModalId + 'continue', this.continueUpload, this);

            //If a filename selected, render it
            //IE9 fix for undefined variable this.file
            this.file = this.$uploadInput.files ? this.$uploadInput.files[0] : null;
            if (this.file) {
                this.renderFileName(this.file.name);
            }

            //submit buttons
            this.$submitBOMButton = this.$('.quf-bom-submit');
            this.$uploadButton = this.$('.quf-upload-submit');
            this.$dealIdButton = this.$('.quf-id-form-submit');
            this.$buttons = this.$('button');

            //textarea
            this.$textareaBOM = this.$('.textareaBOM');

            this.$parseBomStrategy = this.$('[name="copyPasteOption"]');

            // select
            this.$selectVendorRef = this.$('.select-vendor-ref');

            //file upload components
            this.apiUrl = this.$uploadForm.data('url');
            this.quoteStatusModel = new ws.models.quoteFileUploadModel();
            this.uid = this.$el.data('uid');

            if (this.uid === 'westcon_ca') {
                this.uid = 'westcon';
            }

            this.$formSubmittedMessage = this.$('.quf-submitting-message');
            this.$stillWaitingMessage = this.$('.quf-still-pending-message');

            this.$globalMessage = this.$('.qut-upload-error');
            this.$errorMessageContainer = this.$('.quf-error-file');
            this.genericErrorMessage = this.$globalMessage.html();
            this.orderStatusInterval = Number($.trim(this.$('.cqc-status-interval').html()));

            //Added for DTE-27738
            this.$vendorRefDiv = this.$('.request-quote-vendorref');
            this.$quoteDescription = this.$('.quoting-description');
            this.$tabsNavDiv = this.$('.quf-nav');
            this.$quoteEnteredId = this.$('#quf-enter-id');
            this.$quoteCopyPaste = $('#quf-copy-paste');
            this.$requestQuote = this.$('.request-quote');

            //Uplaod BOM URLs
            this.storefront = sitePath === '/quote' ? 'quoting' : 'westcon';
            this.$vendorDropDown = this.$('#vendorId');

            // Decimal Points
            this.resellerDecimalsPointsSelect = this.$('select[name="reseller-decimals-points"]');
            this.resellerDecimalsPointsInput = this.$('input[name="resellerDecimalPoints"]');

            this.enableInputs();
            this.render();
            this.quoteId = this.getQuoteId();
            this.$quoteNumerInput = this.$('[name="quoteNum"]').val(this.quoteId);

            this.$isBulkDAQuoteSubmited = this.$('#isBulkDAQuoteSubmited');
            this.showLargeQuoteItemPopup();
            this.eventAgg.on('ws.views.searchPartNumber:selectedPartNumbers', this.addPartNumbersToBOMField, this);
        },

        /**
         * Enable all inputs/buttons (fixes back button issue)
         */
        enableInputs: function () {
            this.$buttons.prop('disabled', false);
            this.$buttons.removeClass('spinner-before no-padding');
            this.$textareaBOM.attr('readonly', false);
            this.$vendorRefNumb.prop('readonly', false);
        },

        /**
         * Getting the quoteId from the url
         */
        getQuoteId: function() {
            let url = window.location.pathname.split('/');
            return url[url.length - 1];
        },

        /**
         * Render
         */
        render: function () {
            //IE9 fix for undefined variable this.file
            this.file = this.$uploadInput.files ? this.$uploadInput.files[0] : this.$uploadInput.value.match(/[^\/\\]+$/);

            if (this.file) {
                this.$fileName.html(this.file.name);
            }

            if (!this.$copyBomGlobalMsgs.is(':empty')) {
                this.$copyBom.find('.quf-error').css('visibility', 'visible');
                this.$copyBomGlobalMsgs.show();
            }

            this.eventAgg.trigger(this.successModalId);

            //Added for DTE-27738
            var urlParts = window.location.href.split('/');
            var lastSegment = urlParts.pop() || urlParts.pop();  // handle potential trailing slash

            if (lastSegment === 'requestaquote') {
                this.$tabsNavDiv.hide();
                this.$requestQuote.removeClass('hide');
                this.$quoteDescription.removeClass('hide');
            }

            if (lastSegment === 'requestaquotebyvendorrefno') {
                this.$vendorRefDiv.removeClass('hide');
                this.$tabsNavDiv.hide();
                this.$quoteEnteredId.addClass('active');
                this.$quoteEnteredId.show();
                this.$quoteCopyPaste.hide();
            }
        },

        /**
         * Show file name
         */
        renderFileName: function (fileName) {
            this.$fileName.html(fileName);
        },

        /**
         * Update vendor state
         */
        updateVendorSelect: function () {
            this.$vendorErrorMessage.hide();
        },

        /**
         * Update vendor Reference
         */
        updateVendorSelectRef: function () {
            var valueSelected = this.$selectVendorRef.val();
            var selectVendorRefData = this.$selectVendorRef.data('attr');
            var examplePlaceholder = this.$('.vendor-ref-place-holder').val();

            this.$vendorRefNumb.attr('placeholder', !_.isEmpty(valueSelected) ? examplePlaceholder + ' ' + selectVendorRefData[valueSelected] : '');
        },

        showLargeQuoteItemPopup: function () {
            if (this.$isBulkDAQuoteSubmited.val()) {
                setTimeout(function () {
                    this.eventAgg.trigger('largeQuoteModalPopup');
                    this.$dealIdButton.prop('disabled', true);
                }.bind(this), 500);
            }
        },

        /**
         * Show Tooltip
         * @param {Object} e
         */
        showTooltip: function (e) {
            e.preventDefault();
            var tooltip = $(e.currentTarget).children('.tooltip');
            tooltip.toggle();
            this.$('.tooltip').not(tooltip).hide();
        },

        /**
         * Form Error Check
         * @param {Object} form
         */
        emptyFieldCheck: function (form) {
            var missingFields = [];
            var requiredFields = form.find('.required');
            var vendorError = this.$vendorErrorMessage;
            requiredFields.each(function () {
                if (!$.trim($(this).val())) {
                    if ($(this)[0].tagName === 'SELECT') {
                        vendorError.show();
                    }

                    $(this).addClass('error');
                    missingFields.push($(this));
                }
            });

            if (missingFields.length > 0) {
                return missingFields;
            }
        },

        /**
         * process selected file
         */
        processFile: function (e) {
            this.$globalErrors.css('visibility', 'hidden');

            //this.extensionCheck(e);
            if (this.$bomCheckbox.prop('checked') === true) {
                this.validateFile();
            } else {
                this.uploadFile();
            }
        },

        /* Extension Check */

        extensionCheck: function (e) {
            var fileName = e.target.files[0].name;
            var file = fileName.split('.');
            var fileExtension = file[file.length - 1].toLowerCase();
            if (fileExtension === 'exe') {
                this.$uploadButton.prop('disabled', true);
                this.$uploadFile.find('.exe-error').css('visibility', 'visible');
            } else {
                this.$uploadButton.prop('disabled', false);
                this.$uploadFile.find('.exe-error').css('visibility', 'hidden');

            }
        },

        /**
         * Delete uploaded File
         */
        deleteFile: function () {
            this.$fileName.html('');
            this.$uploadInput.type = 'text';
            this.$uploadInput.type = 'file';
        },

        /**
         * Validate file
         */
        validateFile: function () {
            //IE9 fix for undefined variable this.file
            this.file = this.$uploadInput.files ? this.$uploadInput.files[0] : this.$uploadInput.value.match(/[^\/\\]+$/);

            if (this.file) {
                var fileName = this.file.name;
                var fileType = this.file.type;
                var file = fileName.split('.');
                var fileExtension = file[file.length - 1].toLowerCase();
                var allowedType = this.bomFileTypes;
                var allowedExtensions = this.bomExtensions;

                if (allowedType.indexOf(fileType) === -1 || allowedExtensions.indexOf(fileExtension) === -1) {
                    this.$uploadFile.find('form')[0].reset();
                    this.$fileName.html('');
                    this.$errorMessageContainer.show();
                    this.$fileUploadError.hide();
                    this.$fileUploadFormatError.show();
                } else {
                    this.uploadFile();
                }
            }
        },

        /**
         * Upload file
         */
        uploadFile: function () {

            //IE9 fix for undefined variable this.file
            var fileName = this.$uploadInput.files ? this.$uploadInput.files[0].name : this.$uploadInput.value.match(/[^\/\\]+$/);
            if (fileName) {
                this.$errorMessageContainer.hide();
                this.eventAgg.trigger(this.successModalId);

                this.$fileName.html(_.template(this.$uploadFileTpl.html())({items: fileName}));
            }
        },

        /**
         * Confirm Upload
         * @param {Object} e
         */
        confirmUpload: function (e) {
            //IE9 fix for undefined variable this.file
            this.file = this.$uploadInput.files ? this.$uploadInput.files[0] : this.$uploadInput.value.match(/[^\/\\]+$/);
            if (this.file) {
                e.preventDefault();
                this.eventAgg.trigger(this.confirmModalId);
            }
        },

        /**
         * Continue upload
         */
        continueUpload: function () {
            this.deleteFile();
            this.$uploadInput.click();
        },

        /**
         /**
         * uploadFile
         * @param {Object} e
         */
        checkUploadFileForm: function (e) {
            e.preventDefault();
            this.$globalErrors.html('');
            var missingFields = this.emptyFieldCheck(this.$uploadForm);
            if (missingFields) {
                this.$errorMessageContainer.show();
                this.$uploadFile.find('.quf-error').css('visibility', 'visible');

                $.each(missingFields, function (index, value) {
                    if (value.hasClass('upload')) {
                        this.$fileUploadFormatError.hide();
                        this.$fileUploadError.show();
                        return false;
                    } else if (value.hasClass('sales-office')) {
                        this.eventAgg.trigger('salesOfficeValidation');
                        if (missingFields.length === 1) {
                            this.eventAgg.trigger('focusSalesOfficeField');
                            this.$fileUploadError.hide();
                        }
                    } else {
                        this.$fileUploadFormatError.hide();
                        this.$fileUploadError.hide();
                        this.$vendorErrorMessage.show();
                    }
                }.bind(this));
            } else {
                this.$errorMessageContainer.hide();
                this.$buttons.prop('disabled', true);
                this.$uploadButton.addClass('spinner-before');
                this.resellerDecimalsPointsInput.val(this.resellerDecimalsPointsSelect.val());
                this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_UPLOAD_FILE_ACTION, this.$vendorDropDown.val());
                this.submitWithDelay(this.$uploadForm);
                localStorage.setItem(this.GTM_NEW_QUOTE_EVENT_LABEL_STORAGE, this.GTM_NEW_QUOTE_EVENT_LABEL_UPLOAD);
            }
        },

        /**
         * Check Deal ID Form
         * @param {Object} e
         */
        checkIdForm: function (e) {
            e.preventDefault();
            this.$globalErrors.html('');
            var missingFields = this.emptyFieldCheck(this.$dealId.find('form'));
            var duplicateFieldCheck = false;

            if ($('.unique').length) {
                let quotesArray = [];
                $('.unique').each(function () {
                    if ($(this).val() && quotesArray.includes($(this).val())) {
                        $(this).addClass('error');
                        duplicateFieldCheck = true;
                    } else {
                        quotesArray.push($(this).val());
                    }
                });
            } else {
                duplicateFieldCheck = false;
            }

            if (missingFields) {
                this.$dealId.find('.quf-error').css('visibility', 'visible');
                this.$('.quf-enter-id-fields-error').show();
                this.$('.global-error-message').hide();
                $.each(missingFields, function (index, missingField) {
                    if (missingField.hasClass('sales-office')) {
                        this.eventAgg.trigger('salesOfficeValidation');
                        if (missingFields.length === 1) {
                            this.eventAgg.trigger('focusSalesOfficeField');
                            this.$('.quf-enter-id-fields-error').hide();
                        }
                    }
                }.bind(this));
            } else if (duplicateFieldCheck) {
                this.$dealId.find('.quf-error').css('visibility', 'visible');
                this.$('.duplicate-quote-fields-error').show();
                this.$('.global-error-message').hide();
            } else {
                this.$dealId.find('.quf-error').css('visibility', 'hidden');
                this.$dealIdButton.addClass('spinner-before').prop('disabled', true);
                this.$buttons.prop('disabled', true);
                this.$vendorRefNumb.prop('readonly', true);
                this.resellerDecimalsPointsInput.val(this.resellerDecimalsPointsSelect.val());
                this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_VENDOR_ACTION, this.$selectVendorRef.val());
                this.adobeAddProduct('by vendor reference', this.$selectVendorRef.val());
                this.submitWithDelay(this.$dealId.find('form'));
                localStorage.setItem(this.GTM_NEW_QUOTE_EVENT_LABEL_STORAGE, this.GTM_NEW_QUOTE_EVENT_LABEL_API);
            }
        },

        /**
         * Check BOM form
         * @param {Object} e
         */
        checkBOMForm: function (e) {
            e.preventDefault();
            this.$globalErrors.html('');
            var missingFields = this.emptyFieldCheck(this.$copyBom.find('form'));

            if (missingFields) {
                this.$copyBom.find('.quf-error').css('visibility', 'visible');
                this.$copyBomGlobalMsgs.hide();
                this.$('.quf-bom-empty-fields').show();
                this.$('.global-error-message').hide();
                $.each(missingFields, function (index, missingField) {
                    if (missingField.hasClass('sales-office')) {
                        this.eventAgg.trigger('salesOfficeValidation');
                        if (missingFields.length === 1) {
                            this.eventAgg.trigger('focusSalesOfficeField');
                            this.$('.quf-bom-empty-fields').hide();
                        }
                    }
                }.bind(this));
            } else {
                this.$submitBOMButton.prop('disabled', true);
                this.$buttons.prop('disabled', true);
                this.$submitBOMButton.addClass('spinner-before');
                this.$textareaBOM.attr('readonly', true);
                this.resellerDecimalsPointsInput.val(this.resellerDecimalsPointsSelect.val());
                this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_PART_NUMBER_ACTION);
                this.adobeAddProduct('by bill of material', $('.textareaBOM').val());
                this.submitWithDelay(this.$copyBom.find('form'));
                localStorage.setItem(this.GTM_NEW_QUOTE_EVENT_LABEL_STORAGE, this.GTM_NEW_QUOTE_EVENT_LABEL_MANUAL);
            }
        },

        /**
         * Reset form
         * @param {Object} e
         */
        resetForm: function (e) {
            $(e.currentTarget).removeClass('error');
            $('.required-error-message').hide();
            if (!this.$('.error').is(':visible')) {
                this.$errors.css('visibility', 'hidden');
            }
        },

        /**
         * timeout to let Safari change style on form's elements before submission
         * @param {Object} form - The form to be submitted
         */
        submitWithDelay: function (form) {
            setTimeout(function () {
                if (form.hasClass('quf-upload-form')) {
                    this.submitForm();
                } else {
                    let contentHavingNotes = this.$textareaBOM.val().split(/"/);
                    let acceptableNotes = ['P-Q-IN', 'P-Q-RP-IN', 'P-Q-LP-WC-RP-IN'];
                    if (contentHavingNotes.length > 2 && acceptableNotes.includes(this.$parseBomStrategy.val())) {
                        let contentWithNotesAndProducts = [];
                        contentHavingNotes.forEach((item, index) => {
                            if ((index % 2) === 1) {
                                contentWithNotesAndProducts.push(contentHavingNotes[index - 1] + item.split(/\n/).join('~'));
                            }
                        });

                        this.$textareaBOM.val(contentWithNotesAndProducts.join('\n'));
                    }

                    if (form.hasClass('quf-id-form') && isQuotingSite) {
                        this.submitDealIdViaAjax(form);
                    } else {
                        form.submit();
                    }
                }
            }.bind(this), 500);
        },

        submitDealIdViaAjax: function () {
            const form = document.getElementsByClassName('quf-id-form');
            const formData = new FormData(form[0]);
            const jsonData = Object.fromEntries(formData.entries());
            jsonData.quoteNumber = jsonData.quoteNum;
            delete jsonData.quoteNum;
            let optionalDealIdArr = [];
            $('input[name=optionalDealIds]').each(function(e) {
                optionalDealIdArr.push($(this).val());
            });

            jsonData.optionalDealIds = optionalDealIdArr.join(',');
            globals.disableApp();
            $.ajax({
                url: globals.path.api.quoting.ajaxDealIdSubmit + '?' + CSRF,
                type: 'POST',
                data: JSON.stringify(jsonData),
                contentType: 'application/json',
                success: (res) => {
                    globals.enableApp();
                    $('.global-error-message-ajax .alert').empty();
                    this.$submitBOMButton.prop('disabled', false);
                    this.$buttons.prop('disabled', false);
                    this.$submitBOMButton.removeClass('spinner-before');
                    $('.quf-id-form-submit').removeClass('spinner-before');
                    $('.quf-id-form input').removeAttr('readonly');
                    $('.global-error-message-ajax').addClass('hide');
                    if ((res.accConfMsgList && res.accConfMsgList.length) || (res.accInfoMsgs && res.accInfoMsgs.length) || (res.accErrorMsgs && res.accErrorMsgs.length)) {
                        if (res.accConfMsgList && res.accConfMsgList.length) {
                            let accConfMsgs = res.accConfMsgList.join('</br>');
                            $('.global-error-message-ajax .alert').append(accConfMsgs);
                        }

                        if (res.accInfoMsgs && res.accInfoMsgs.length) {
                            let accInfoMsgs = res.accInfoMsgs.join('</br>');
                            $('.global-error-message-ajax .alert').append(accInfoMsgs);
                        }

                        if (res.accErrorMsgs && res.accErrorMsgs.length) {
                            let accErrorMsgs = res.accErrorMsgs.join('</br>');
                            $('.global-error-message-ajax .alert').append(accErrorMsgs);
                        }

                        $('.global-error-message-ajax').removeClass('hide');
                    }

                    if (res.bulkDAQuoteSubmited) {
                        this.eventAgg.trigger('largeQuoteModalPopup');
                        globals.getProgressStatus(true, true);
                        return;
                    }

                    if (res.redirectUrl.includes('quoteDetail')) {
                        window.location.href = window.location.origin + '/quote/' + res.redirectUrl;
                    }

                    globals.getProgressStatus(true, true);
                },

                error: function(jqXHR, textStatus, errorThrown) {
                    globals.enableApp();
                    this.$submitBOMButton.prop('disabled', false);
                    this.$buttons.prop('disabled', false);
                    this.$submitBOMButton.removeClass('spinner-before');
                    $('.quf-id-form-submit').removeClass('spinner-before');
                    $('.quf-id-form input').removeAttr('readonly');
                    globals.getProgressStatus(true, true);
                }
            });

            globals.getProgressStatus(false, false, false, true);
        },

        /**
         * Submit file upload Form and wait for complete status
         */
        submitForm: function() {
            var fd = new FormData();
            var url = '';
            this.$errorMessageContainer.hide();

            fd.append('vendorId', this.$('[name=vendorId]').val());

            fd.append('salesOffice', this.$('[name=salesOffice]').val());
            fd.append('file', this.$uploadInput.files[0]);
            if (this.$multiUpload.val() === 'true') {
                url = globals.path.api.quoting.uploadMultiQuote + '?' + CSRF;
            } else {
                url = globals.path.api[this.storefront].uploadBom + '?' + CSRF;
                fd.append('quoteNum', this.quoteId);
                fd.append('optionalQuoteNumber', this.$optionalQuoteNo.val() ? this.$optionalQuoteNo.val() : '');
                fd.append('resellerDecimalPoints', $('.reseller-decimals-points').val() ? $('.reseller-decimals-points').val() : '');
            }

            var submitForm = $.ajax({
                type: 'POST',
                url: url,
                data: fd,
                processData: false,
                contentType: false
            });

            submitForm.done(function (data) {
                this.$formSubmittedMessage.show();

                if (data) {
                    if (data.error) {
                        if (this.$multiUpload.val() === 'true') {
                            this.$formSubmittedMessage.hide();
                        }

                        this.showUploadFileErrorMessage(data.error);
                    }

                    switch (data.status) {
                        case 'pending':
                            this.$errorMessageContainer.hide();

                            //file upload model
                            this.quoteStatusModel.url = globals.path.api[this.storefront].uploadBomStatus + '/' + this.quoteId + '?' + CSRF;

                            this.getOrderStatus();
                            break;
                        case 'submitted':
                            this.$errorMessageContainer.hide();
                            if (this.$multiUpload.val() === 'true') {
                                this.$fileName.html('');
                                this.$formSubmittedMessage.hide();
                                this.$uploadButton.removeClass('spinner-before').prop('disabled', false);
                                this.eventAgg.trigger(this.uploadSuccessModalId);
                            } else {
                                this.redirectToConfirmationPage(data);
                            }

                            break;
                    }
                }

            }.bind(this)).fail(function() {
                this.$errorMessageContainer.show();
                this.$uploadButton.removeClass('spinner-before').prop('disabled', false);
            }.bind(this));

        },

        /**
         * Redirect to page
         */
        redirectToConfirmationPage: function() {
            window.location.href = globals.path.api[this.storefront].quoteDetailsUrl.replace('{quoteId}', this.quoteId);
        },

        /**
         * Show Upload error messages on BOM file upload
         */
        showUploadFileErrorMessage: function(message) {
            this.$errorMessageContainer.css({
                visibility: 'visible'
            });
            this.$errorMessageContainer.show();
            this.$uploadButton.removeClass('spinner-before').prop('disabled', false);
            this.$globalMessage.html(message);
            this.$globalMessage.show();
        },

        /**
         * Get order status until success
         */
        getOrderStatus: function() {
            globals.disableApp();
            var timeElapsed = 0;
            this.$formSubmittedMessage.show();
            this.$stillWaitingMessage.hide();

            var getOrderStatus = setInterval(function() {
                this.quoteStatusModel.fetch().done(function(response) {
                    if ($('.submit-spinner-text').length === 0) {
                        $('body').append(`
                            <div class='submit-spinner-text'><p>${response.extInProgressMsg ? response.extInProgressMsg : 'Do not Refresh the page or click on the back button'}</p></div>
                        `);
                    }

                    if (response.extInProgressMsg) {
                        $('.submit-spinner-text').text(response.extInProgressMsg);
                    }

                    switch (response.status) {
                        case 'pending':
                            timeElapsed++;
                            if (timeElapsed === 4) {
                                this.$formSubmittedMessage.hide();
                                this.$stillWaitingMessage.show();
                            }

                            break;
                        case 'submitted':
                            clearInterval(getOrderStatus);
                            this.redirectToConfirmationPage(response);
                            break;
                        case 'error':
                            $('.submit-spinner-text').remove();
                            globals.enableApp();
                            clearInterval(getOrderStatus);
                            var errorMessage = (response.error) ? response.error : this.genericErrorMessage;
                            this.showUploadFileErrorMessage(errorMessage);
                            this.$formSubmittedMessage.hide();
                            this.$stillWaitingMessage.hide();
                            break;
                    }
                }.bind(this)).fail(function() {
                    clearInterval(getOrderStatus);
                    this.showUploadFileErrorMessage(this.genericErrorMessage);
                    this.$formSubmittedMessage.hide();
                    this.$stillWaitingMessage.hide();
                    this.$saveButton.removeClass('spinner-before').prop('disabled', false);
                }.bind(this));
            }.bind(this), this.orderStatusInterval);
        },

        /**
         * Receives the list of selected part numbers and adds them to the BOM field
         * @param {Array} selectedPartNumbersList - List of selected part numbers
         */
        addPartNumbersToBOMField: function (selectedPartNumbersList) {
            var partNumberOnlyOption = 'P';
            var hasQuantities = (this.$parseBomStrategy.val() !== partNumberOnlyOption);
            var partNumbersList = [];

            // Add previous part numbers in the BOM field
            _.each(this.$textareaBOM.val().trim().split(/[\n]+/g), function (each) {
                partNumbersList.push(each.trim().split(/\s*[,\s]\s*/).join(' '));
            });

            // Add selected part numbers in search modal
            _.each(selectedPartNumbersList, function (each) {
                partNumbersList.push(each + (hasQuantities ? ' 1' : ''));
            });

            this.$textareaBOM.val(partNumbersList.join('\n').trim());
        },

        /* Toggle Check for Merge QUotes and QuoteRevision*/
        toggleOptionInputBox: function(e) {
            if (e.target.value === 'mergeQuote') {
                this.$('.showOptionalDeal').show();
                this.$('.showOptionRev').hide();
            } else {
                this.$('.showOptionalDeal').hide();
                this.$('.showOptionRev').show();
            }
        },

        /**
         * adobe add product to quote
         */
        adobeAddProduct: function (action, data) {

            dataLayerAA.cart = {};
            dataLayerAA.cart.category = 'quote';
            dataLayerAA.cart.type = 'add';
            dataLayerAA.cart.action = action;
            dataLayerAA.cart.data = data;
            // _satellite.track('event:cart');
        }
    });
})(westcon);
